import { useTranslation } from 'react-i18next'

import { RevenueSplitModel } from '../../../../../types/court/court'
import {
  createCurrencyFormatter,
  createPercentFormatter,
} from '../../../../../utils/locale/localeUtils'

interface RevenueSplitProps {
  revenue: RevenueSplitModel
  locale: string
}

export const RevenueSplit = ({ revenue, locale }: RevenueSplitProps) => {
  const { t } = useTranslation('reports')

  const currencyFormatter = createCurrencyFormatter(locale, {
    maximumFractionDigits: 0,
  })

  const percentFormatter = createPercentFormatter(locale, {
    maximumFractionDigits: 0,
  })
  const totalRevenue = revenue.memberships + revenue.payPerPlay
  const membershipsPercentage =
    totalRevenue === 0 ? 0 : (revenue.memberships / totalRevenue) * 100
  const payPerPlayPercentage =
    totalRevenue === 0 ? 0 : (revenue.payPerPlay / totalRevenue) * 100

  return (
    <div className="reports-revenue-content">
      <div className="ph-row reports-revenue-values">
        <div>
          <div className="eyebrow">{t('reports.revenue.memberships')}</div>
          <div className="display reports-revenue-value">
            {currencyFormatter.format(revenue.memberships)}
          </div>
          <div className="muted tiny">
            {t('reports.revenue.of-revenue', {
              value: percentFormatter.format(membershipsPercentage / 100),
            })}
          </div>
        </div>
        <div>
          <div className="eyebrow">{t('reports.revenue.pay-per-play')}</div>
          <div className="display reports-revenue-value">
            {currencyFormatter.format(revenue.payPerPlay)}
          </div>
          <div className="muted tiny">
            {t('reports.revenue.of-revenue', {
              value: percentFormatter.format(payPerPlayPercentage / 100),
            })}
          </div>
        </div>
      </div>

      <div className="ph-row reports-revenue-bar">
        <div
          className="reports-revenue-memberships"
          style={{ width: `${membershipsPercentage}%` }}
        />
        <div
          className="reports-revenue-pay-per-play"
          style={{ width: `${payPerPlayPercentage}%` }}
        />
      </div>
    </div>
  )
}
